export default {
  name: 'listItem',
  props: {
    listData: {
      type: Object,
      required: true
    }
  }
}
